import _apply from "ramda/es/apply";

var mathMinSpread = _apply(Math.min);

export default mathMinSpread;